// extracted by mini-css-extract-plugin
export default {"root":"ImageFromFile_root__aUdt5","rootForImage":"ImageFromFile_rootForImage__uZb39"};